import { jsx } from "react/jsx-runtime";
import { Hidden, Box } from "braid-design-system";
import { callout, positionRight, positionLeft } from "./Callout.css.mjs";
const Callout = ({ children, className = "", position }) => {
  const positionClassName = position === "right" ? positionRight : positionLeft;
  return /* @__PURE__ */ jsx(Hidden, { below: "tablet", children: /* @__PURE__ */ jsx(Box, { className: [className, callout, positionClassName], children }) });
};
export {
  Callout
};
